import { mutationRequest } from 'services/mutation/mutationRequest';
import { getLatLong } from 'components/modals/getLatLong';

import { MODIFY_VENUE } from 'constants/mutationConstants';

export function setLatLong(_e: any, cell: any): void {
  const rowData = cell.getRow().getData();
  const { latitude, longitude } = rowData?.address || {};
  const callback = (value: any = {}) => {
    if (!rowData.address) rowData.address = {};
    const venue = rowData.venue;
    if (!venue.addresses) venue.addresses = [];
    if (venue.addresses.length) {
      Object.assign(venue.addresses[0], { latitude: value.latitude, longitude: value.longitude });
    } else {
      venue.addresses.push({ latitude: value.latitude, longitude: value.longitude });
    }

    const postMutation = (result: any) => {
      if (result.results?.[0]?.success) {
        const table = cell.getTable();
        rowData.address.latitude = value.latitude;
        rowData.address.longitude = value.longitude;
        rowData.hasLocation = value.latitude && value.longitude;
        table.updateData([rowData]);
      }
    };

    const methods = [
      {
        method: MODIFY_VENUE,
        params: {
          venueId: rowData.venueId,
          modifications: {
            addresses: venue.addresses,
          },
        },
      },
    ];

    mutationRequest({ methods, callback: postMutation });
  };

  getLatLong({ coords: { latitude, longitude }, callback });
}
